<template>
    <div v-if="hasErrors">
        <div class="font-medium text-red-600">Whoops! Something went wrong.</div>

        <ul class="mt-3 list-disc list-inside text-sm text-red-600">
            <li v-for="(error, key) in errors" :key="key">
                <span v-if="isBlockedEmailError(error)">
                    Your email has been blocked from accessing RentRisk. Please 
                    <a href="https://rentrisk.com/contact" class="underline text-blue-600 hover:text-blue-800">contact support</a> 
                    if you need assistance.
                </span>
                <span v-else>{{ error }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        computed: {
            errors() {
                return this.$page.props.errors
            },

            hasErrors() {
                return Object.keys(this.errors).length > 0;
            },
        },
        methods: {
            isBlockedEmailError(error) {
                return error && error.includes('blocked from accessing RentRisk');
            }
        }
    }
</script>